import { Observable } from 'rxjs'
import { Transaction } from '../../models/transaction.model'

export abstract class TransactionService {
  abstract getTransactions(executionId: number): Observable<Transaction[]>
}
